<template>
  <div id="LsmartERP">
    <div class="smartERP ERP-page">
      <div class="container">
        <div class="space"></div>
        <div class="card-columns">
          <div class="card card-order-list card-margin shadow border-light">
            <div class="card-body">
              <h6 class="card-title">ชื่ออุปกรณ์ : Mac'air00123</h6>
              <br />

              <form action="" class="form-group">
                <div class="card-input">
                  <!-- <img
                    class="card-img-left flex-auto d-md-block zoom"
                    src="../../assets/img/computer1.jpg"
                    alt="Card image cap"
                    id="cardimg"
                  /> -->
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder=""
                    disabled
                    value="locat: ห้องคอม 1"
                  />
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder=""
                    required
                    value="เลขครุภัณฑ์ : TH2298494040404040"
                  />
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder="รหัสนักศึกษา/รหัสอาจารย์"
                    required
                  />
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder="รหัสนักศึกษา/รหัสอาจารย์"
                    required
                  />
                 <!--  -->
                 <input
                    type="text"
                    class="form-control input-style"
                    placeholder=""
                    disabled
                    value="locat: ห้องคอม 1"
                  />
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder=""
                    required
                    value="เลขครุภัณฑ์ : TH2298494040404040"
                  />
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder="รหัสนักศึกษา/รหัสอาจารย์"
                    required
                  />
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder="รหัสนักศึกษา/รหัสอาจารย์"
                    required
                  />
                
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LsmartERP",
  data() {
    return {};
  },
};
</script>

<style scoped>
.ERP-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
.space {
  height: 50px;
}
.smartERP {
  background: -webkit-linear-gradient(-55deg, #c55fb8 40%, #ae4bbb 100%)
    no-repeat center center;
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}

@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");

#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #ebf0fc;
  border-color: #ebf0fc;
  color: #9da3b0;
}
.neworder-content {
  position: relative;
  right: 170px;
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
}
.card-content-more {
  position: relative;
}

.fa-purple {
  color: rgb(109, 7, 172);
}
.card-title {
  text-align: left;
  /* text-align: justify; */
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  /* bottom: 5px; */
}

/* card-input */

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-input {
    column-count: 3;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-input {
    column-count: 3;
  }
}
img {
  height: 100px;
  width: auto;
}

@media screen and (max-width: 576px) {
  img {
    height: 160px;
    width: auto;
  }
}

@media screen and (max-width: 767px) {
  img {
    height: 100px;
    width: auto;
  }
}
/* card-left-img */
.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}

</style>
